module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row3"
  }, [_vm._l((_vm.catelist), function(row, i) {
    return (i >= 1) ? _c('img', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'NewsList',
          query: {
            cate_id: row.id
          }
        }),
        expression: "{name:'NewsList',query:{cate_id:row.id}}"
      }],
      attrs: {
        "src": row.pic_url
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(row, i) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'NewsDetail',
          query: {
            id: row.id
          }
        }),
        expression: "{name:'NewsDetail',query:{id:row.id }}"
      }],
      key: i
    }, [(row.pics.length == 0) ? _c('NewsItem1', {
      attrs: {
        "row": row
      }
    }) : _vm._e(), _vm._v(" "), (row.pics.length == 1) ? _c('NewsItem2', {
      attrs: {
        "row": row
      }
    }) : _vm._e(), _vm._v(" "), (false) ? _c('NewsItem3') : _vm._e(), _vm._v(" "), (row.pics.length > 1) ? _c('NewsItem4', {
      attrs: {
        "row": row
      }
    }) : _vm._e()], 1)
  }), 0)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bccea52","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/page/Guojijiaoliu.vue
// module id = 1441
// module chunks = 0